import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { MEDIUM_SOY, WHITE } from 'reservations/brand/constants';

type PageLoadSpinnerProps = {
  message?: string;
  isLoading?: boolean;
};

// TODO: Rough implementation. We should come back to this when we implement spinners with messages
function PageLoadSpinner({ message, isLoading = false }: PageLoadSpinnerProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <Backdrop
      open={isLoading}
      data-testid="page-loading-spinner"
      sx={theme => ({
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: `rgba(0, 0, 0, 1)`,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      })}
    >
      <CircularProgress sx={{ color: MEDIUM_SOY }} />
      {!!message && (
        <Typography component="p" sx={{ color: WHITE, fontWeight: 500 }}>
          {message}
        </Typography>
      )}
    </Backdrop>
  );
}

export default PageLoadSpinner;
